import { render, staticRenderFns } from "./ZyJsonForms.vue?vue&type=template&id=2fe8fc13&scoped=true"
import script from "./ZyJsonForms.vue?vue&type=script&lang=js"
export * from "./ZyJsonForms.vue?vue&type=script&lang=js"
import style0 from "./ZyJsonForms.vue?vue&type=style&index=0&id=2fe8fc13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8fc13",
  null
  
)

export default component.exports